import { initialState } from 'store/utils';

export default {
    find: {
        ...initialState,
    },
};
